import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sidebar" }

import Page from "@/components/Page.vue";
import {computed, onMounted, ref} from "vue";
import {PageGroup} from "@/types/dto";
import {addRouter} from "@/router";
import {ElMessageBox} from "element-plus";
import {pageStore} from "@/store/pageStore";

const onRoutes = "/"

export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

const collapse = computed((): boolean => {
  return false;
});

const dashboard: PageGroup = {
  page: "/dashboard",
  title: "系统首页",
  itemList: []
};
const items = ref<PageGroup[]>([
  dashboard
]);
onMounted(() => {
  pageStore().queryPage().then((data) => {
    items.value = [dashboard].concat(data);
    // 加入路由
    addRouter(data)
  }).catch(err => {
    ElMessageBox.alert("页面信息加载失败,请刷新页面重试", "错误");
  })
})

return (_ctx: any,_cache: any) => {
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      class: "sidebar-el-menu",
      "default-active": onRoutes,
      collapse: collapse.value,
      "background-color": "#324157",
      "text-color": "#bfcbd9",
      "active-text-color": "#20a0ff",
      "unique-opened": "",
      router: ""
    }, {
      default: _withCtx(() => [
        _createVNode(Page, { items: items.value }, null, 8, ["items"])
      ]),
      _: 1
    }, 8, ["collapse"])
  ]))
}
}

})